import {TokenService} from "../../services/token.service";

export default {
    computed: {
        orders() {
            return TokenService.getUserObj().msp_forsage_orders
        }
    }
}